// this file added by Bearer Web Developer
import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import styles from './verificationForm.module.scss';
import { observer } from 'mobx-react-lite';
import { validateEmailCode, validateMobileCode } from './validation';
import { useAppState } from '../../../states/app-state';
import EmailCodeData from './emailCodeData';
import MobileCodeData from './mobileCodeData';
import DisabledClickLoading from '../../../components/DisabledClickLoading';
import { useThemeMode } from '../../../states/contexts/theme';

const VerificationForm: React.FC = observer(() => {

    const appState = useAppState();
    const { accountVerification } = appState;
    const [loading, setLoading] = useState(false);
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (checkvalidation()) {
            // console.log(accountVerification.getCodeData());
            setLoading(true);
            await accountVerification?.fetchRegisterBusinessCustomerSubmitVerification();
            setLoading(false);
        }
    }
    useEffect(() => {
        return () => {
            setLoading(false);
        }
    }, [])
    function checkvalidation() {
        let validation = true;
        validation = !validateEmailCode(accountVerification.emailCode) &&
            !validateMobileCode(accountVerification.mobileCode) &&
            accountVerification?.emailCodeSituation === "Verified" &&
            accountVerification?.mobileCodeSituation === "Verified"
        return validation;
    }
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <form onSubmit={handleSubmit} className={styles.account_form} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <EmailCodeData />
            <MobileCodeData />
            <div>
                <Button type='submit' className={styles.button} disabled={!checkvalidation()} disableRipple={true}>
                    <span>Submit</span>
                </Button>
            </div>
            {loading && <DisabledClickLoading />}
        </form>
    )
});
export default VerificationForm;